import ActionsForNew from "./ActionsForNew";

export default ActionsForNew;
